module.exports = __webpack_public_path__ + "static/media/localhost.992d8f90.png";